import { EnvironmentProviders, Injectable, Provider } from "@angular/core";
import { OrdersRoutesProvider } from "./lib/routes/orders.routes";

@Injectable({ providedIn: 'root' })
export class OrdersConfigService {
    constructor() {}
}

export const provideOrders = (): Array<Provider | EnvironmentProviders> => {
    return [
        { provide: OrdersRoutesProvider.getToken(), useClass: OrdersRoutesProvider, multi: true },
    ];
}
